__turbopack_context__.v({
  "active": "_0QnoqW_active",
  "language": "_0QnoqW_language",
  "languageLink": "_0QnoqW_languageLink",
  "languageList": "_0QnoqW_languageList",
});
